/**
 * プルダウンメニューの制御を行う関数
 */
export const pulldown = () => {
  const pulldownElements = document.querySelectorAll( '.js-pulldown' );

  pulldownElements.forEach( pulldownElement => {
    const displayElement = pulldownElement.querySelector( '.js-pulldown-display' );
    const displayTextElement = displayElement.querySelector( '.js-pulldown-display-text' );
    const list = pulldownElement.querySelector( '.js-pulldown-list' );

    /**
     * checked がついているものをディスプレイに表示させる
     */
    list.querySelectorAll( 'input' ).forEach( input => {
      if ( input.checked === true ) {
        displayTextElement.textContent = $( input ).next().text();
      }

      /**
       * プルダウン選択時の処理
       */
      input.addEventListener( 'change', () => {
        displayTextElement.textContent = $( input ).next().text();
        displayElement.classList.remove( 'is--open' );
        $( list ).stop().slideUp( 100 );
      } );
    } );

    /**
     * ディスプレイをクリックで一覧が表示される
     */
    displayElement.addEventListener( 'click', () => {
      $( displayElement ).toggleClass( 'is--open' );

      if ( displayElement.classList.contains( 'is--open' ) ) {
        $( list ).stop().slideDown( 100 );
      } else {
        $( list ).stop().slideUp( 100 );
      }
    } );
  } );
}
